$b.on("keyup", function (e) {
    if (helpers.isEscape(e)) {
        $(".dropdown").removeClass("is-open");
        $(".dropdown").find(".options a").attr("tabindex", "-1");
        $(".menu-item-has-children").removeClass("active");
        $(".menu-item-has-children .sub-menu a").attr("tabindex", "-1");
        $b.removeClass("mini-cart-shown search-shown");
        helpers.closeModals();
        helpers.removeMiniCartFocus();
        helpers.removeSearchFocus();
        helpers.returnFocus();
    }
});

/*
Navigation
*/
$("#navigation-open").on("click", function (e) {
    e.preventDefault();
    $b.addClass("navigation-shown");
});
$("#navigation-close").on("click", function (e) {
    e.preventDefault();
    $b.removeClass("navigation-shown");
    $("#site-navigation .active").removeClass("active");
    // $("#navigation-back").removeClass("shown");
});

$(".sub-menu a").attr("tabindex", -1);
$(".menu-item-has-children > a").on("click", function (e) {
    e.preventDefault();
    let $parent = $(this).closest("li");
    window.menuItemToClose = $parent;
    $(".sub-menu a").attr("tabindex", "-1");
    if ($parent.hasClass("active")) {
        $parent.removeClass("active");
        $('#menu-primary').removeClass('has-active');
    } else {
        $(".menu-item-has-children").removeClass("active");
        $parent.addClass("active");
        window.returnFocusTo = $(this);
        $parent.find(".sub-menu a").removeAttr("tabindex");
        $parent.find('.sub-menu [href="#"]').attr("tabindex", "-1");
        helpers.trapFocus(`#${$parent.attr("id")}`);
        $('#menu-primary').addClass('has-active');
        // $("#navigation-back").addClass("shown");
    }
});

// $("#navigation-back").on("click", function (e) {
//     e.preventDefault();
//     window.menuItemToClose.removeClass("active");
//     if (!$(".menu-item-has-children.active").length) {
//         $(this).removeClass("shown");
//     }
// });

$('#menu-primary > li').each(function () {
    const $firstLevel = $(this).children('.sub-menu');
    if ($firstLevel.length) {
        $firstLevel.each(function () {
            const $secondLevel = $(this).find('.sub-menu');
            if ($secondLevel.length) {
                $firstLevel.addClass('has-nested-submenus');
            }
        });
    }
});

/*
mini cart
*/
$("#mini-cart-open").on("click", function (e) {
    e.preventDefault();
    window.returnFocusTo = $(this);
    $b.removeClass("search-shown");
    $b.toggleClass("mini-cart-shown");
    $("#mini-cart").find("a, button").removeAttr("tabindex");
    helpers.trapFocus("#mini-cart");
});
$b.on("click", "#mini-cart-close", function (e) {
    e.preventDefault();
    $b.removeClass("mini-cart-shown");
    helpers.removeMiniCartFocus();
    helpers.returnFocus();
});

/*
drop downs
*/
$(".dropdown .toggle").on("click", function (e) {
    e.preventDefault();
    let $parent = $(this).closest(".dropdown");
    let $options = $parent.find(".options");
    $parent.toggleClass("is-open");
    if ($parent.hasClass("is-open")) {
        window.returnFocusTo = $(this);
        $(this).attr("aria-expanded", true);
        $parent.find(".options a").removeAttr("tabindex");
        helpers.trapFocus(`#${$options.attr("id")}`);
    } else {
        $(this).attr("aria-expanded", false);
        $parent.find(".options a").attr("tabindex", "-1");
    }
});

/*
archive working states
*/
$(".archive-toolbar .dropdown .options a").on("click", function (e) {
    $b.addClass("working");
});

/*
modals
*/
$(".modal-close").on("click", function (e) {
    e.preventDefault();
    helpers.closeModals();
});

/*
search
*/
$("#search-open").on("click", function (e) {
    e.preventDefault();
    window.returnFocusTo = $(this);
    $b.removeClass("mini-cart-shown");
    $b.addClass("search-shown");
    $("#site-search-input").select();
    $("#search-panel").find("input, button").removeAttr("tabindex");
    helpers.trapFocus("#search-panel", false);
});
$("#search-close").on("click", function (e) {
    e.preventDefault();
    $b.removeClass("search-shown");
    helpers.returnFocus();
    helpers.removeSearchFocus();
});

/*
Messages
*/
var messageMods = function () {
    $(".woocommerce-message").each(function () {
        if (
            !$(this).find(".message-close").length &&
            !$(this).hasClass("persistent")
        ) {
            $(this).append(window.messageAssets.close);
        }
        if (!$(this).find(".has-arrow svg").length) {
            $(this).find(".has-arrow").append(window.messageAssets.arrowRight);
        }
    });
};
$b.on("click", ".message-close", function (e) {
    e.preventDefault();
    $(this).closest(".woocommerce-message").fadeOut();
});
// page load
messageMods();
// after cart ajax
$(document.body).on("updated_cart_totals", function () {
    messageMods();
});
$(document.body).on("updated_checkout", function () {
    if (!$("#place_order").find("svg").length) {
        $("#place_order").append(window.messageAssets.arrowRight);
    }
});

/*
Back to top

$("#back-to-top").on("click", function (e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: 0 }, 500);
});
var setToTopState = function () {
    let $btn = $("#back-to-top");
    if ($(window).scrollTop() > document.body.clientHeight * 0.2) {
        $btn.addClass("enabled");
    } else {
        $btn.removeClass("enabled");
    }
};
$(window).on("scroll", window.helpers.throttle(500, setToTopState));
*/
/*
Conservation category has different UI
*/
if ($("#conservation-filter").length) {
    $b.addClass("is-conservation");
}

$(".faq .toggle").on("click", function (e) {
    e.preventDefault();
    $(this).closest(".question").toggleClass("is-open");
});
$("#faq-all").on("click", function (e) {
    e.preventDefault();
    if ($(this).hasClass("collapsed")) {
        $(".question").addClass("is-open");
        $(this).removeClass("collapsed").text("Collapse All");
    } else {
        $(".question").removeClass("is-open");
        $(this).addClass("collapsed").text("Expand All");
    }
});

$("#dealer-portal button").on("click", function (e) {
    e.preventDefault();
    if ($(this).attr("aria-expanded") === "true") {
        $(this).attr("aria-expanded", false);
    } else {
        $(this).attr("aria-expanded", true);
    }
});
